import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { AutoComplete } from "primereact/autocomplete";
import { Controller, useForm } from "react-hook-form";
import { debounce } from "lodash";
import "../../assets/styles/items/newItem.scss";
import ItemsService from "../../services/items";
import {
  Dialog,
  Button,
  InputText,
  InputTextarea,
  Dropdown,
  Toast,
  ToggleButton,
} from "../PrimeReact";
import { Row } from "react-bootstrap";
import GV from "../../services/globalVar";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import JournalService from "../../services/journal";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";





const NewItem = forwardRef((props, ref) => {
  const { isOpen, onClose, prodList, onSuccess } = props;
  const toast = useRef(null);
  const jor = new JournalService();

  const schema = yup.object().shape({
  type: yup.string().required("This field is required"),
  name: yup.string().required("This field is required"),
  baseunit: yup.string().required("This field is required"),
  code: yup.string().required("This field is required"),
  status: yup.string().required("This field is required"),
  stocks: yup.string(),

  enablePerItem: yup.boolean(),

  secondaryunit: yup.string().when("enablePerItem", {
    is: true,
    then: (schema) => schema.required("Item per Unit is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  secondarycount: yup.number().when("enablePerItem", {
    is: true,
    then: (schema) =>
      schema
        .typeError("Item per Count must be a number")
        .required("Item per Count is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bottlePerLitre: yup.string().when(["enablePerItem", "secondaryunit"], {
    is: (enable, unit) =>
      enable === true && unit?.trim().toLowerCase() === "bottles",
    then: (schema) =>
      schema
        .required("Bottle per Litre is required")
        .test("is-number", "Bottle per Litre must be a number", (value) => !isNaN(value)),
    otherwise: (schema) => schema.notRequired(),
  }),

  salescheck: yup.boolean(),
  sellingprice: yup.string(),
  description: yup.string(),

  costcheck: yup.boolean(),
  costprice: yup.string(),
  description1: yup.string(),

  taxpreference: yup.string(),
  cgst: yup
    .number()
    .typeError("CGST must be a number")
    .required("This field is required")
    .min(0, "CGST cannot be negative"),
  sgst: yup
    .number()
    .typeError("SGST must be a number")
    .required("This field is required")
    .min(0, "SGST cannot be negative"),
  igst: yup
    .number()
    .typeError("IGST must be a number")
    .required("This field is required")
    .min(0, "IGST cannot be negative"),
});
  //     useEffect(() => {
  //   return () => {
  //     Object.values(jor.controllers).forEach((c) => c.abort());
  //     jor.controllers = {}; 
  //   };
  // }, []);
  const categories = [
    { name: "Business", key: "A" },
    { name: "Individual", key: "M" },
  ];
  const [selectedAccount1, setSelectedAccount1] = useState(null);
  const [selectedAccount2, setSelectedAccount2] = useState(null);
  const [accounts1, setAccounts1] = useState(false);
  const [accounts2, setAccounts2] = useState(false);
  const [accountVl, setAccountVl] = useState("");
  const [accountVl1, setAccountVl1] = useState("");
  const [itemData, setItemData] = useState([]);
  const [upDisabled, setUpDisabled] = useState(true);
  const [upDisabled1, setUpDisabled1] = useState(true);
  const [siCheck, setSiCheck] = useState(false);
  const [piCheck, setPiCheck] = useState(false);
  const [itemID, setItemID] = useState(0);
  const [displaynewItem, setdisplaynewItem] = useState(false);
  const [position, setPosition] = useState("center");
  const [accountList, setAccountList] = useState([]);
  const [taxPreference, setTaxPreference] = useState("");
  const [isProcess, setIsProcess] = useState(false);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [selectedTaxCode, setSelectedTaxCode] = useState(null);
  const its = new ItemsService();
  //     useEffect(() => {
  //   return () => {
  //     Object.values(its.controllers).forEach((c) => c.abort());
  //     its.controllers = {}; 
  //   };
  // }, []);

  // let iId = props.data.itemId;

  const defaultValues = {
    type: "",
    name: "",
    baseunit: "",
    secondaryunit: "",
    secondarycount: "",
    bottlePerLitre: "",
    stocks: "",
    code: "",

    salescheck: false,
    sellingprice: "",
    // siAccount: "",
    status: "",
    description: "",

    costcheck: false,
    costprice: "",
    // piAccount: "",
    description1: "",
    enablePerItem: false,
    taxpreference: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    watch,
    setValue,
    getValues,
    trigger,
    clearErrors,
  } = useForm({ mode: "all", defaultValues, resolver: yupResolver(schema) });

  const resetAsyncForm = async () => {
    reset();
  };
 const enablePerItem = watch("enablePerItem");
  const checkValidation = (e) => {
    if (e.target.checked) {
      setValue("salescheck", true);
    } else {
      setValue("salescheck", false);
      clearErrors(["sellingprice", "siAccount", "description"]);
    }
    if (getValues("salescheck")) {
      setUpDisabled(false);
      schema = yup.object().shape({
        ...schema.fields,
        sellingprice: yup.string().required("This field is required"),
        // siAccount: yup.string().required("This field is required"),
        // description: yup.string().required('This field is required')
      });
    } else {
      setUpDisabled(true);
      schema = yup.object().shape({
        ...schema.fields,
        sellingprice: yup.string().notRequired(""),
        // siAccount: yup.string(),
        status: yup.string(),
        description: yup.string(),
      });
    }
  };
  const [filteredCodes, setFilteredCodes] = useState([]);
  const [newTaxCodeLabel, setNewTaxCodeLabel] = useState("");

  const searchTaxCode = async (event) => {
    const query = event.query;

    const typeCode = watchType === "goods" ? "HSN" : "SAC";
    const payload = {
      TaxType: typeCode,
      TaxCode: query,
    };

    try {
      const response = await jor.GetMasTaxCode(payload);
      const data = response.data?.data || [];

      if (data.length === 0) {
        setFilteredCodes([
          { taxCode: `+ Add "${query}"`, taxCodeID: "__new__" },
        ]);
        setNewTaxCodeLabel(query);
      } else {
        setFilteredCodes(data);
      }
    } catch (err) {
      console.error("Error fetching tax codes", err);
    }
  };
  const debouncedSearch = useCallback(debounce(searchTaxCode, 300), []);

  const checkCostValidation = (e) => {
    setValue("costcheck", e.target.checked);
    if (e.target.checked) {
      setValue("costcheck", true);
    } else {
      setValue("costcheck", false);
      clearErrors(["costprice", "piAccount", "description1"]);
    }
    let copySchema = schema;
    if (getValues("costcheck")) {
      copySchema = yup.object().shape({
        ...schema.fields,
        costprice: yup.string().required("This field is required"),
        // piAccount: yup.string().required("This field is required"),
        // description1: yup.string().required('This field is required')
      });
    } else {
      setUpDisabled(true);
      copySchema = yup.object().shape({
        ...schema.fields,
        costprice: yup.string().notRequired(""),
        // piAccount: yup.string(),
        description1: yup.string(),
      });
    }
    schema = copySchema;
  };

  useImperativeHandle(ref, () => ({
    alertToggle() {
      onClick("displaynewItem");
      setSelectedTaxCode(null);
    },
    alertToggledit(val) {
      onClickEdit("displaynewItem", val);
    },
  }));

const units = [
    { label: "Piece", value: "Piece" },
    { label: "Box", value: "box" },
    { label: "Cartons", value: "Cartons " },
    { label: "Case", value: "Case" },
    { label: "Pack", value: "pack" },
    { label: "Bundle", value: "Bundle" },
    { label: "Bottles", value: "Bottles " },
    { label: "Pair", value: "pair" },
    { label: "Dozen", value: "dozen" },
    { label: "Liter", value: "Liter" },
    { label: "Milliliter", value: "Milliliter" },
    { label: "Kilogram", value: "Kilogram" },
    { label: "Gram", value: "Gram" },
    { label: "Meter", value: "Meter" },
    { label: "Centimeter", value: "Centimeter" },
    { label: "Square Meter", value: "Square Meter" },
    { label: "Cubic Meter", value: "Cubic Meter" },
    { label: "Hour", value: "Hour" },
    { label: "Day", value: "Day" },
    { label: "Service", value: "Service" }
  ];

  const taxpre = [
    { id: 1, name: "Taxable", value: "Taxable" },
    { id: 2, name: "Non-taxable", value: "Non-taxable" },
    { id: 3, name: "Out of scope", value: "Out of scope" },
    { id: 4, name: "Non-GST Supply", value: "Non-GST Supply" },
  ];


  const onAccountChange1 = (e) => {
    setSelectedAccount1(e.value);
    setAccountVl(e.value.code);
    setItemData(e.target.value);
    setAccounts1(true);
  };

  const onAccountChange2 = (e) => {
    setSelectedAccount2(e.value);
    setAccountVl1(e.value.code);
    setItemData(e.target.value);
    setAccounts2(true);
  };

  const dialogFuncMap = {
    displaynewItem: setdisplaynewItem,
  };

  const onClickEdit = (name, value) => {
    console.log("value in onClickEdit:", value);
    dialogFuncMap[`${name}`](true);
    resetAsyncForm();
    setItemID(value.itemID);
    setValue("type", value.itemType);
    setValue("name", value.name);
    setValue("baseunit", value.unit);
    setValue("secondaryunit", value.secUnit);
    setValue("secondarycount", value.secStocks);
    setValue("bottlePerLitre", value.terStocks);
    setValue("stocks", value.stocks);
    setValue("salescheck", value.isSale);
    setValue("code", value.saCorHSNCode);

    setValue("costcheck", value.isPurchase);
    setValue("sellingprice", value.siSellingPrice);
    // setValue("siAccount", value.siAccount);
    setValue("description", value.siDescription);
    setValue("costprice", value.piCostPrice);
    // setValue("piAccount", value.piAccount);
    setValue("description1", value.piDescription);
    setValue("enablePerItem", value.isSecUnit);

    setValue("taxpreference", value.taxPreference);
    setValue("cgst", value.centralTaxRate);
    setValue("sgst", value.localTaxRate);
    setValue("igst", value.interTaxRate);

    const taxPre = taxpre.find((a) => a.value === value.taxPreference);
    setTaxPreference(taxPre.value);

    if (value.status === "Active") {
      setValue("status", true);
    } else {
      setValue("status", false);
    }

    // setUpDisabled(false);
    // setSiCheck(true);

    if (position) {
      setPosition(position);
    }
  };
  const handleSelectTaxPreference = (e) => {
    //    data.sgst
    setTaxPreference(e.target.value);
  };

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);
    resetAsyncForm();
    setUpDisabled(true);
    setSiCheck(false);
    setPiCheck(false);
    setUpDisabled1(true);
    setItemID(0);
    setValue("status", true);
    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    dialogFuncMap[`${name}`](false);
    setTaxPreference("");
    resetAsyncForm();
    setValue("salescheck", false);
    clearErrors(["sellingprice", "siAccount", "description"]);
 if (onClose) onClose();
    schema = yup.object().shape({
      ...schema.fields,
      sellingprice: yup.string(),
      // siAccount: yup.string(),
    });
    schema = yup.object().shape({
      ...schema.fields,
      costprice: yup.string(),
      // piAccount: yup.string(),
    });
  };

  const onInvalid = (errors) => console.error(errors);

  const onSubmit = (data) => {
    setIsProcess(true);
    const payload = {
      ITemID: itemID,
      ItemType: data.type,
      Name: data.name, 
      Unit: data.baseunit,
      SecUnit: data.secondaryunit || null,
      IsSecUnit: data.enablePerItem,
      SecStocks: data.secondarycount || 0,
      "IsTerUnit": watch("secondaryunit")?.trim().toLowerCase() === "bottles",
      "TerUnit": watch("secondaryunit")?.trim().toLowerCase() === "bottles" ? "Litre" : null,
      "TerStocks": data.bottlePerLitre || 0,
      ServiceCodeName: data.type === "service" ? "SAC" : "HSC",
      SACorHSNCode: data.code,
      TaxPreferenceID: 0,
      TaxPreference: taxPreference === "" ? "Non-taxable" : taxPreference,
      LocalTaxName: "SGST",
      LocalTaxRate: taxPreference === "Taxable" ? data.sgst : 0,
      LocalTaxAmount: 0,
      InterTaxName: "IGST",
      InterTaxRate: taxPreference === "Taxable" ? data.igst : 0,
      InterTaxAmount: 0,
      CentralTaxName: "CGST",
      CentralTaxRate: taxPreference === "Taxable" ? data.cgst : 0,
      CentralTaxAmount: 0,
      isSale: data.salescheck,
      SISellingPrice: data.sellingprice || 0.0,
      SIAccount: "",
      SIDescription: data.description || "",
      isPurchase: data.costcheck,
      PICostPrice: data.costprice || 0.0,
      PIAccount: "",
      PIDescription: data.description1 || "",
      VendorID: 0,
      VendorName: "",
      TenantID: GV.userDet.tenantDetail.tenantID,
      Status: data.status === "true" ? "Active" : "InActive",
      Stocks: data.stocks || 0,
      CreatedBy: GV.userDet.appUser.userName,
    };
    console.log("Payload for Item:", payload);
    its
      .SaveItems(payload)
      .then((res) => {
        setIsProcess(false);
        if (res.data.message === "Successfully added Items") {
          if (props.onSuccess) props.onSuccess();
          toast.current.show({
            severity: "success",
            summary: res.data.message,
          });
          props.parentFunction();
        }
        if (res.data.message === "Successfully modified Items") {
          props.parentFunction();
          toast.current.show({
            severity: "success",
            summary: res.data.message,
          });
        }

        if (
          res.data.message !== "Successfully added Items" &&
          res.data.message !== "Successfully modified Items"
        ) {
          toast.current.show({
            severity: "error",
            summary: res.data.message,
          });
        }
        dialogFuncMap["displaynewItem"](false);
      })
      .catch(function (error) {
        setIsProcess(false);
        if (error.response.data.statusCode === 500) {
          setIsProcess(false);
          toast.current.show({
            severity: "error",
            summary: error.response.data.message,
          });
        }
      });
  };

const renderFooter = (name) => {
  return (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={() => onHide("displaynewItem")}
        className="p-button-text btn-cancel"
      />
      <Button
        type="submit"
        label={itemID != "" && itemID != 0 ? "Update" : "Save"}
        icon="pi pi-check"
        onClick={handleSubmit(onSubmit,onInvalid)}
        autoFocus
        className="btn btn-primary"
      />
    </div>
  );
};

useEffect(() => {
    reset();
}, [isOpen])

  const changeVal = (ev) => {};
  const initMethods = () => {
    jor
      .GetMasCOA(0, GV.userDet.tenantDetail.tenantID, "Active", "All")
      .then((response) => {
        let b = [];
        if (response.data) {
          if (response.data.statusCode === 200) {
            const data = response.data.data;
            let accounts = [];
            data.forEach((x) => {
              x.category.forEach((y) => {
                accounts = [...accounts, y];
              });
              x.subCategory.forEach((z) => {
                accounts = [...accounts, z];
              });
            });
            setAccountList(accounts);
          } else {
          }
        }
        // }
      })
      .catch(function (error) {});
  };

  watch("type");

  const watchType = watch("type");

  const GetMasTaxCode = (type) => {
    const typeCode = type === "goods" ? "HSN" : "SAC";
    const payload = {
      TaxType: typeCode,
      TaxCode: "",
    };
    jor.GetMasTaxCode(payload).then((response) => {
      if (response.data?.statusCode === 200) {
        const data = response.data.data;
        setTaxCodeList(data);
      }
    });
  };


  
const secondaryunit = watch("secondaryunit");
const baseunitValue = watch("baseunit");

const secondaryUnitOptions = units.filter((unit) => unit.value !== baseunitValue);

useEffect(() => {
  trigger(["secondaryunit", "secondarycount"]);
}, [enablePerItem]);

useEffect(() => {
  if (secondaryunit?.trim().toLowerCase() !== "bottles") {
    setValue("bottlePerLitre", "");
    clearErrors("bottlePerLitre");
  }
}, [secondaryunit]);


  useEffect(() => {
    register("type");
    register("status");
    initMethods();
  }, [register]);

  return (
    <div>
      <BlockUI blocked={isProcess}>
        <Toast ref={toast}></Toast>

        <Dialog
          header={itemID != "" || itemID != 0 ? "Update Item" : "New Item"}
          visible={displaynewItem || isOpen}
          onHide={() => onHide("displaynewItem", onClose)}
          breakpoints={{ "960px": "75vw" }}
          style={{ width: "60vw" }}
          footer={renderFooter("displaynewItem")}
        >
          <form >
            <div className="form-group row text-start">
              <div className="row">
      <div className="col">
        <fieldset className="enhanced-legend">
          <legend className="enhanced-legend float-none w-auto p-2">BASIC INFO</legend>
          <div className="row pe-0">
            {/* Type */}
            <div className="col-md-3">
              <label className="form-label mb-1 required">Type</label>
              <div className="px-1 pt-2 mb-1">
                <label className="me-4">
                  <input type="radio" {...register("type")} value="goods" /> Goods
                </label>
                <label>
                  <input type="radio" {...register("type")} value="service" /> Service
                </label>
              </div>
              {errors.type && (
                <p className="text-danger mb-0 ps-1">{errors.type.message}</p>
              )}
            </div>

            {/* Name */}
            <div className="col-md-6 pe-4">
              <label className="form-label mb-1 p-0 required">Name</label>
              <input
                type="text"
                className="form-control px-1 py-2"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <p className="text-danger mb-0 ps-1">{errors.name.message}</p>
              )}
            </div>

            {/* Status */}
            <div className="col-md-3 pe-0 px-4">
              <Row>
                <label className="p-0 form-label mb-1 required">Status</label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <ToggleButton
                      style={{ width: "35%" }}
                      {...field}
                      checked={field.value}
                      className="item-status"
                      onLabel="Active"
                      offLabel="Inactive"
                      onIcon="pi pi-check"
                      offIcon="pi pi-times"
                    />
                  )}
                />
                {errors.status && (
                  <p className="text-danger mb-0 ps-1">{errors.status.message}</p>
                )}
              </Row>
            </div>

            <div className="row">
              <div className="col-md-4">
                <label className="form-label mb-1 p-0 required">
                  {watch("type") === "goods" ? "HSN" : "SAC"} Code
                </label>
                <input
                  type="text"
                  className="form-control px-1 py-2"
                  {...register("code", { required: "Code is required" })}
                />
                {errors.code && (
                  <p className="text-danger mb-0 ps-1">{errors.code.message}</p>
                )}
              </div>

              <div className="col-md-4 px-4">
                <Row>
                  <label className="p-0 form-label mb-1 required">Unit</label>
                  <Controller
                    name="baseunit"
                    control={control}
                    rules={{ required: "Unit is required" }}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        options={units}
                        appendTo="self"
                        className="unit-dropdown"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Unit"
                      />
                    )}
                  />
                </Row>
                {errors.baseunit && (
                  <p className="text-danger mb-0 p-0">{errors.baseunit.message}</p>
                )}
              </div>

              <div className="col-md-4">
                <label className="form-label mb-1 p-0">Stock</label>
                <input
                  type="text"
                  className="form-control px-1 py-2"
                  defaultValue={itemData.stocks}
                  {...register("stocks")}
                />
                {errors.stocks && (
                  <p className="text-danger mb-0 ps-1">{errors.stocks.message}</p>
                )}
              </div>

              <div className="col-md-12 px-2 mt-2 ">
                <input
                  type="checkbox"
                  {...register("enablePerItem")}
                  id="enablePerItem"
                  className="form-check-input me-2"
                />
                <label htmlFor="enablePerItem" className="form-check-label">
                  Enable Per Item Info
                </label>
              </div>

              <div className="col-md-4 px-4">
                <Row>
                  <label className={`p-0 form-label mb-1 ${enablePerItem ? "required" : ""}`}>
                   Item per Unit
                  </label>
                  <Controller
                    name="secondaryunit"
                    control={control}
                    rules={{
                      required: enablePerItem ? "Item per Unit is required" : false,
                    }}
                    render={({ field }) => (
                      <Dropdown
                        {...field}
                        options={secondaryUnitOptions}
                        appendTo="self"
                        className="unit-dropdown"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Unit"
                        disabled={!enablePerItem}
                      />
                    )}
                  />
                  {errors.secondaryunit && (
                    <p className="text-danger mb-0 p-0">{errors.secondaryunit.message}</p>
                  )}
                </Row>
              </div>

              <div className="col-md-4 px-2">
                <label className={`form-label mb-1 p-0 ${enablePerItem ? "required" : ""}`}>
                    Item per Count
                </label>
                <input
                  type="text"
                  className="form-control px-1 py-2"
                  {...register("secondarycount", {
                    required: enablePerItem ? "Item per Count is required" : false,
                    disabled: !enablePerItem,
                  })}
                />
                {errors.secondarycount && (
                  <p className="text-danger mb-0 ps-1">{errors.secondarycount.message}</p>
                )}
              </div>
             {watch("secondaryunit")?.trim().toLowerCase() === "bottles" && (
  <div className="col-md-4 px-2">
    <label className="form-label mb-1 p-0 required">Bottle Volume (mL)</label>
    <input
      type="text"
      className="form-control px-1 py-2"
      {...register("bottlePerLitre", {
        required: "Bottle per Litre is required",
        validate: (value) =>
          !isNaN(value) || "Bottle per Litre must be a number",
      })}
    />
    {errors.bottlePerLitre && (
      <p className="text-danger mb-0 ps-1">{errors.bottlePerLitre.message}</p>
    )}
  </div>
)}


            </div>
          </div>
        </fieldset>
      </div>
    </div>

              <div className="form-group row">
                <div className="col">
                  <fieldset className="enhanced-legend">
                    <legend className="enhanced-legend float-none w-auto p-2">
                      Tax Preference
                      <Controller
                        render={({ field }) => (
                          <Dropdown
                            options={taxpre}
                            onChange={(e) => handleSelectTaxPreference(e)}
                            style={{ width: "300px" }}
                            value={taxPreference}
                            defaultValue={taxpre[0].value}
                            // {...field}
                            appendTo="self"
                            className="unit-dropdown ms-2"
                            optionLabel="name"
                            optionValue="value"
                            placeholder=""
                            // {...register('taxpreference')}
                          />
                        )}
                        control={control}
                        name="taxpreference"
                      />
                    </legend>
                    {taxPreference === "Taxable" && (
                      <div className="row">
                        <div className="col">
                          <label>CGST (%)</label>
                          <input
                            type="number"
                            {...register("cgst")}
                            className="form-control"
                          />
                          {errors.cgst && (
                            <p className="text-danger mb-0 ps-1">
                              {errors.cgst?.message}
                            </p>
                          )}
                        </div>
                        <div className="col">
                          <label>SGST (%)</label>
                          <input
                            type="number"
                            {...register("sgst")}
                            className="form-control"
                          />
                          {errors.sgst && (
                            <p className="text-danger mb-0 ps-1">
                              {errors.sgst?.message}
                            </p>
                          )}
                        </div>
                        <div className="col">
                          <label>IGST (%)</label>
                          <input
                            type="number"
                            {...register("igst")}
                            className="form-control"
                          />
                          {errors.igst && (
                            <p className="text-danger mb-0 ps-1">
                              {errors.igst?.message}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>
              </div>

              {isProcess && (
                <ProgressSpinner
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                  strokeWidth="2"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              )}
              <div className=" form-group row ">
                <div className="col">
  <fieldset className="enhanced-legend">
    <legend className="enhanced-legend float-none w-auto p-2">
      <input
        className="form-check-input me-2"
        type="checkbox"
        {...register("salescheck")}
        onChange={(e) => checkValidation(e)}
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
        Sales Information
      </label>
    </legend>
    <div className="w-100">
      <div className="row">
        <label
          className={`form-label mb-1 ${watch("salescheck") ? "required" : ""}`}
          htmlFor="name"
        >
          Selling Price
        </label>

        <div className="input-group input-group-sm">
          <span className="input-group-text" id="basic-addon1">
            {GV.userDet.tenantConfig.currency}
          </span>
          <input
            type="number"
            className="form-control px-1 py-2"
            {...register("sellingprice", {
              disabled: watch("salescheck") === false,
            })}
          />
        </div>

      <small className="text-muted ps-3 mt-1">
  Note: Please enter the net amount {baseunitValue && ` per ${baseunitValue}`} excluding tax percentage
</small>
        {errors.sellingprice && (
          <p className="text-danger mb-0 ps-3">
            {errors.sellingprice?.message}
          </p>
        )}
      </div>

      <div className="mt-0">
        <label className="form-label mb-1" htmlFor="description">
          Description
        </label>
        <textarea
          type="text"
          className="form-control px-1 py-2"
          {...register("description", {
            disabled: watch("salescheck") === false,
          })}
        />
      </div>
    </div>
  </fieldset>
</div>


                <div className="col">
                  <fieldset className="enhanced-legend">
                    <legend className="enhanced-legend float-none w-auto p-2">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        {...register("costcheck")}
                        onChange={(e) => checkCostValidation(e)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        Purchases Information
                      </label>
                    </legend>
                    <div className="w-100">
                      <div className="row">
                        <label
                          className={`form-label mb-1 ${
                            watch("costcheck") ? "required" : ""
                          }`}
                          htmlFor="name"
                        >
                          Cost Price
                        </label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text" id="basic-addon1">
                            {GV.userDet.tenantConfig.currency}
                          </span>
                          <input
                            type="number"
                            className="form-control px-1 py-2"
                            {...register("costprice", {
                              required: watch("costcheck")
                                ? "Cost Price is required"
                                : false,
                              disabled: watch("costcheck") === false,
                            })}
                          />
                        </div>
                        <small className="text-muted ps-3 mt-1" style={{ visibility: 'hidden' }}>
  Note: Please enter the net amount per unit
</small>
                        {errors.costprice && (
                          <p className="text-danger mb-0 ps-3">
                            {errors.costprice?.message}
                          </p>
                        )}
                      </div>
                      {/* <div className="form-group row mx-0 mb-1">
                        <label
                          className={`col-sm-4 col-form-label mb-1 pb-0 ps-0 ${
                            watch("costcheck") ? "required" : ""
                          }`}
                        >
                          Account
                        </label>
                        <Controller
                          render={({ field }) => (
                            <Dropdown
                              options={accountList}
                              onChange={onAccountChange2}
                              {...field}
                              appendTo="self"
                              optionLabel="coaName"
                              optionValue="coaName"
                              disabled={watch("costcheck") === false}
                            />
                          )}
                          control={control}
                          name="piAccount"
                          defaultValue={itemData.piAccount}
                          rules={{
                            required: watch("costcheck")
                              ? "Account is required"
                              : false,
                          }}
                        />
                        {errors.piAccount && (
                          <p className="text-danger mb-0 p-0">
                            {errors.piAccount?.message}
                          </p>
                        )}
                      </div> */}
                      <div className="mt-0">
                        <label
                          className="form-label mb-1"
                          htmlFor="description"
                        >
                          Description
                        </label>
                        <textarea
                          type="text"
                          className="form-control px-1 py-2"
                          {...register("description1", {
                            disabled: watch("costcheck") === false,
                          })}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              {/* </div> */}
            </div>
          </form>
        </Dialog>
      </BlockUI>
    </div>
  );
});

export default NewItem;
